import PropTypes from 'prop-types';

// @mui
import {
  Card,
  Box,
} from '@mui/material';





export default function RowBase({ children }) {
  return (
    <Box mt={2} >
      <Card sx={{bgcolor: '#E6E7E9',p: 1}} >
        {children}
      </Card>
    </Box>

  );
}
RowBase.propTypes = {
};
RowBase.defaultProps = {
}